import { useState } from "react";

import { VimeoPlayer } from "@/components";
import { howCarePlansWorkSlides, VIMEO_VIDEOS } from "@/constants";
import { Carousel, Heading, Modal } from "@/ui";
import { HowCarePlansWorkSlide } from "./how-care-plans-work-slide";

export const HowCarePlansWorkCarousel = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>
      <Modal
        closeModal={() => {
          return setShowVideo(false);
        }}
        isOpen={showVideo}
      >
        <VimeoPlayer
          hash={VIMEO_VIDEOS.HOW_CARE_PLANS_WORK.hash}
          title="How Care Plans Work"
          videoId={VIMEO_VIDEOS.HOW_CARE_PLANS_WORK.id}
        />
      </Modal>
      <div className="mb-10 flex flex-col gap-8 md:gap-14">
        <div className="flex flex-col gap-6">
          <Heading className="text-center" level={2}>
            How Care Plans Work
          </Heading>
          <p className="text-center">
            See below or go a bit deeper and{" "}
            <button
              className="font-bold underline hover:cursor-pointer"
              onClick={() => {
                return setShowVideo(true);
              }}
            >
              watch this 2-minute intro video.
            </button>
          </p>
        </div>
        <Carousel.Root
          className="overflow-visible rounded-2xl"
          options={{ containScroll: false }}
          renderSlide={(slide) => {
            return <HowCarePlansWorkSlide key={slide.id} slide={slide} />;
          }}
          slides={howCarePlansWorkSlides}
        >
          <Carousel.Slider className="overflow-hidden">
            <Carousel.Slides className="xl:-ml-64" />
          </Carousel.Slider>
          <Carousel.ArrowNavigation>
            <Carousel.PrevButton />
            <Carousel.NextButton />
          </Carousel.ArrowNavigation>
          <Carousel.DotsNavigation className="-bottom-11 left-1/2 -translate-x-1/2 transform md:-bottom-14" />
        </Carousel.Root>
      </div>
    </>
  );
};
